<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">Feed Companies</h4>
          <div class="d-flex align-items-center">
            <b-form-group label="Status" label-for="status-select" class="mr-4">
              <b-form-select
                id="status-select"
                v-model="status"
                :options="statusOptions"
                @change="handleFilterChange"
              ></b-form-select>
            </b-form-group>

            <b-form-group label="Feed" label-for="feed-in-select">
              <b-form-select
                id="feed-in-select"
                v-model="feedIn"
                :options="feedInOptions"
                value-field="fullObject"
                text-field="label"
                placeholder="Select a Feed"
                @change="handleFilterChange"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>
        <div class="card-body">
          <div v-if="hasNoCompanies">No Results</div>
          <div class="table-responsive">
            <BTable
              v-if="!hasNoCompanies"
              :items="companies"
              :fields="fields"
              :busy="isTableBusy"
            >
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <template v-slot:head()="data">
                <span class="text-info">{{ data.label }}</span>
              </template>
              <template v-slot:cell(company)="data">
                <div>
                  <img
                    v-if="data.item.logo"
                    :src="data.item.logo"
                    alt="company logo"
                    class="company-logo"
                  />
                  <a :href="getCompanyHref(data.item.id)" target="_blank">{{
                    data.item.company
                  }}</a>
                </div>
              </template>
              <template v-slot:cell(actions)="data">
                <div class="btn-group">
                  <BButton
                    v-if="status === 'pending' || status === 'rejected'"
                    class="fa"
                    v-bind:class="{
                      'fa-check': !isSpinning('approve', data.item.id)
                    }"
                    size="sm"
                    :disabled="disableButtons"
                    variant="success"
                    @click.prevent="
                      handleApproveCompany(data.index, data.item.id)
                    "
                  >
                    <BSpinner
                      class="spinner-border spinner-border-sm"
                      v-if="isSpinning('approve', data.item.id)"
                      label="Spinning"
                    ></BSpinner>
                  </BButton>
                  <BButton
                    v-if="status === 'pending' || status === 'active'"
                    class="fa"
                    v-bind:class="{
                      'fa-times': !isSpinning('reject', data.item.id)
                    }"
                    size="sm"
                    :disabled="disableButtons"
                    variant="danger"
                    @click.prevent="
                      handleRejectCompany(data.index, data.item.id)
                    "
                  >
                    <BSpinner
                      class="spinner-border spinner-border-sm"
                      v-if="isSpinning('reject', data.item.id)"
                      label="Spinning"
                    ></BSpinner>
                  </BButton>
                </div>
              </template>
            </BTable>
            <BPagination
              v-if="showPagination"
              :disabled="isTableBusy"
              v-model="pagination.currentPage"
              @input="fetchCompanies"
              :total-rows="pagination.total"
              :per-page="pagination.perPage"
              align="center"
              aria-controls="company-table"
              class="mt-4"
            ></BPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BTable,
  BPagination,
  BButton,
  BSpinner,
  BFormGroup,
  BFormSelect
} from "bootstrap-vue";

export default {
  components: {
    BTable,
    BPagination,
    BButton,
    BSpinner,
    BFormSelect,
    BFormGroup
  },
  data() {
    return {
      isTableBusy: true,
      companies: [],
      disableButtons: false,
      spinningButton: {
        buttonType: null,
        requestId: null
      },
      fields: ["company", "linkedin_id", "offers_count", "status", "actions"],
      status: "pending",
      statusOptions: ["active", "pending", "rejected"],
      feedIn: null,
      feedInOptions: [
        {
          label: "Québec Emploi",
          fullObject: { name: "quebec_emploi", region: "qc" }
        },
        {
          label: "Jobbank (QC)",
          fullObject: { name: "jobbank", region: "qc" }
        },
        {
          label: "Jobbank (ON)",
          fullObject: { name: "jobbank", region: "on" }
        },
        {
          label: "Jobbank (AB)",
          fullObject: { name: "jobbank", region: "ab" }
        },
        {
          label: "Jobbank (BC)",
          fullObject: { name: "jobbank", region: "bc" }
        },
        {
          label: "Jobbank (MB)",
          fullObject: { name: "jobbank", region: "mb" }
        },
        {
          label: "Jobbank (NB)",
          fullObject: { name: "jobbank", region: "nb" }
        },
        {
          label: "Jobbank (NL)",
          fullObject: { name: "jobbank", region: "nl" }
        },
        {
          label: "Jobbank (NS)",
          fullObject: { name: "jobbank", region: "ns" }
        },
        {
          label: "Jobbank (PE)",
          fullObject: { name: "jobbank", region: "pe" }
        },
        {
          label: "Jobbank (SK)",
          fullObject: { name: "jobbank", region: "sk" }
        },
        {
          label: "Jobbank (NT)",
          fullObject: { name: "jobbank", region: "nt" }
        },
        {
          label: "Jobbank (NU)",
          fullObject: { name: "jobbank", region: "nu" }
        },
        {
          label: "Jobbank (YT)",
          fullObject: { name: "jobbank", region: "yt" }
        },
        {
          label: "HotelsJobs",
          fullObject: { name: "hotelsjobs", region: "qc" }
        },
        {
          label: "RCCAQ",
          fullObject: { name: "emplois_assurance_courtage", region: "qc" }
        },
        {
          label: "Altee",
          fullObject: { name: "altee", region: null }
        }
      ],
      pagination: {
        currentPage: 1,
        total: 0,
        perPage: 20
      }
    };
  },
  computed: {
    hasNoCompanies() {
      return !this.isTableBusy && this.companies.length === 0;
    },
    showPagination() {
      return (
        this.companies.length && this.pagination.total > this.pagination.perPage
      );
    }
  },
  methods: {
    fetchCompanies() {
      this.isTableBusy = true;
      this.$http
        .get("/enroll_admin/feed-companies", {
          params: {
            page: this.pagination.currentPage,
            per_page: this.pagination.perPage,
            status: this.status,
            feed_in_name: this.feedIn?.name,
            feed_in_region: this.feedIn?.region
          }
        })
        .then(({ data }) => {
          this.pagination.currentPage = data.current_page;
          this.pagination.total = data.total;
          this.companies = data.data.map(this.formatResponse);
        })
        .finally(() => (this.isTableBusy = false));
    },
    isSpinning(buttonType, id) {
      return (
        this.spinningButton.buttonType === buttonType &&
        this.spinningButton.requestId === id
      );
    },
    formatResponse(company) {
      return {
        id: company.id,
        company: company.name_fr,
        linkedin_id: company.linkedin_id,
        status: company.status,
        offers_count: company.offers_count,
        isBusy: false,
        logo: company.logo
      };
    },
    handleApproveCompany(index, companyId) {
      this.toggleButtonsState("approve", companyId);
      return this.updateCompany({ companyId, status: "active" }, index);
    },
    updateCompany({ companyId, ...payload }, index) {
      return this.$http
        .put(`/enroll_admin/companies/${companyId}/status`, payload)
        .then(() => {
          this.companies.splice(index, 1);
        })
        .finally(() => {
          this.toggleButtonsState();
        });
    },
    handleRejectCompany(index, companyId) {
      this.toggleButtonsState("reject", companyId);
      return this.updateCompany({ companyId, status: "rejected" }, index);
    },
    toggleButtonsState(buttonType, companyId) {
      this.disableButtons = !this.disableButtons;
      if (this.spinningButton.buttonType === null) {
        this.spinningButton = {
          buttonType,
          requestId: companyId
        };
      } else {
        this.spinningButton = {
          buttonType: null,
          requestId: null
        };
      }
    },
    handleFilterChange() {
      this.pagination.currentPage = 1;
      this.fetchCompanies();
    },
    getCompanyHref(companyId) {
      const route = this.$router.resolve({
        name: "company",
        params: {
          companyId: companyId
        }
      });
      return route.href;
    }
  },
  created() {
    this.fetchCompanies();
  }
};
</script>
